import { useClerk, useUser } from "@clerk/react";

export const useSignOut = () => {
  const clerk = useClerk();
  return clerk.signOut;
};

export const useUserOrThrow = () => {
  const session = useUser();
  if (session.isSignedIn !== true) {
    throw new Error(
      "[useUserOrThrow] Are you using this hook outside of an authenticated route?",
    );
  }
  return session.user;
};
